import { http } from '../../helpers';
import { fetchLabs } from './fetchLabs';

export function deleteLab(id) {
    return (dispatch) => {
        const relativeUrl = `/case-api/labs/${id}`;
        http.delete(relativeUrl)
            .then((res) => {
                if (res.status === 200) {
                    dispatch(fetchLabs());
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    };
}
